import gsap from 'gsap'
import LocomotiveScroll from 'locomotive-scroll'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { initHeroSequence } from './sections/hero-sequence'
import { initCategoriesSequence } from './sections/categories-sequence'
import { initSectionAnimations } from './section-animations'
import { breakpointUp } from './utils/breakpoints'
import { loadElementLazyImage } from './lazy-load'

gsap.registerPlugin(ScrollTrigger)

$(window).on('load', function (e){


  const locoScroll = new LocomotiveScroll({
    el: document.querySelector('.smooth-scroll'),
    smooth: true,
    // for tablet smooth
    tablet: { smooth: true },

    // for mobile
    smartphone: { smooth: true },

    lerp: 0.075
  });

  locoScroll.on("scroll", ScrollTrigger.update)

  setupMenuAction (locoScroll)


  //-- Lazy Load
  let lazyArr = [...document.querySelectorAll('.lazy')]

  locoScroll.on('scroll', function(e){

    lazyArr.forEach(function(el){
      if (checkIfInScreen(el)){
        loadElementLazyImage($(el))
        lazyArr.splice( $.inArray(el, lazyArr), 1 );
      }
    })

  })



// tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
  ScrollTrigger.scrollerProxy(".smooth-scroll", {
    scrollTop(value) {
      return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
    }, // we don't have to define a scrollLeft because we're only scrolling vertically.
    getBoundingClientRect() {
      return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
    },
    // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
    pinType: document.querySelector(".smooth-scroll").style.transform ? "transform" : "fixed"
  });

  initHeroSequence()
  initCategoriesSequence()
  setTimeout(function (){
    initSectionAnimations()

  }, 200)


// each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll.
   ScrollTrigger.addEventListener("refresh", () => locoScroll.update());
//
// // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
   ScrollTrigger.refresh();

   setTimeout(function (){
     locoScroll.update()
     ScrollTrigger.refresh()
     }, 2000)

  $('body').on('click', 'a.scroll-link', function (e){
	 e.preventDefault();
     const target = $(this).data('scroll-id');
     const $targetElement = $(target);
     if ($targetElement.length) {
    	scrollTo(target, locoScroll)
	 } else {
		const href = $(this).attr('href');
        if (href) {
            window.location.href = href;
        }
	}
  })

  // Animate scrolling position
  function scrollTo (menuID, locoScroll) {
    setTimeout(function () {
      if (locoScroll) {
        const target = document.querySelector(menuID)
        locoScroll.scrollTo(target)
      } else {
        const target = document.getElementById(menuID.replace('#', ''))
        var pos = getPosition(target)
        $('html, body').animate({
          scrollTop: pos.y,
        }, 500)
      }
    }, 200)

  }

  /**
   * On page load, resolve hashtag in url
   * @param locoScroll
   */
  function setupMenuAction (locoScroll) {
    if (!window.location.hash) {
      return
    }

    // If locomotive scroll is initialised
    if (locoScroll != null) {
      const target = document.querySelector(window.location.hash)
      if (target) {
		  setTimeout(() => {
			  locoScroll.scrollTo(target);
		  }, 1);
      }
    } else {
      const target = document.getElementById(
        window.location.hash.replace('#', ''))
      if (target) {
        setTimeout(() => {
			var pos = getPosition(target);
			$('html, body').animate({
				scrollTop: pos.y,
			}, 500);
		}, 1);
      }
    }
  }

  function getPosition (element) {
    var top = 0, left = 0
    do {
      top += element.offsetTop || 0
      left += element.offsetLeft || 0
      element = element.offsetParent
    } while (element)

    return {
      y: top,
      x: left,
    }
  }


  function checkIfInScreen(el){
    let vH = window.innerHeight
    let elTop = $(el).offset().top
    let elScreenPosition = 'bottom'
    if ($(el).data('screen-pos') === 'top') elScreenPosition = 'top'
    let offset = 0
    if ($(el).data('screen-offset') !== undefined) offset = $(el).data('screen-offset')

    if (elScreenPosition === 'top'){
      if (elTop - offset < 0){
        return true
      }
    } else {
      if (elTop - offset < vH + 200 && elTop > 0) {
        return true
      }
    }
    return false
  }

})
